import {
  LandingNavbar,
  HeroSection,
  HowItWorksSection,
  WhyRepriScanSection,
  FeaturesSection,
  PricingSection,
  TestimonialsSection,
  FAQSection,
  FinalCTASection,
  LandingFooter,
} from '@/components/landing';
import { SEOHead } from '@/components/seo';

export default function Landing() {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead 
        title="RepriScan - Prédiagnostic de reprise d'entreprise"
        description="Analysez un dossier de reprise en quelques minutes. RepriScan vous donne un verdict clair pour décider rapidement quels projets méritent votre temps."
      />
      <LandingNavbar />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <WhyRepriScanSection />
        <FeaturesSection />
        <PricingSection />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <LandingFooter />
    </div>
  );
}
